var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal-main" },
        [
          _c("h3", [_vm._v("Settings")]),
          _vm._v(" "),
          _c("app-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|latin|checkLatinSymbol|min:1|max:100",
                expression: "'required|latin|checkLatinSymbol|min:1|max:100'"
              }
            ],
            attrs: {
              id: "name",
              label: "Change name",
              name: "name",
              type: "text"
            },
            model: {
              value: _vm.form.tabName,
              callback: function($$v) {
                _vm.$set(_vm.form, "tabName", $$v)
              },
              expression: "form.tabName"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              _c("h4", { staticClass: "mb-0" }, [_vm._v("Display:")]),
              _vm._v(" "),
              !_vm.isFetching
                ? _c(
                    "div",
                    [
                      _c("switch-button", {
                        attrs: { id: "display", checked: _vm.form.display },
                        on: {
                          "update:checked": function($event) {
                            return _vm.$set(_vm.form, "display", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _c("div", {
                    directives: [{ name: "spinner", rawName: "v-spinner" }]
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "primary-btn btn-center",
            attrs: {
              type: "submit",
              disabled: !_vm.formValid || _vm.formPristine
            }
          },
          [_vm._v("Apply\n            ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-386ee0d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386ee0d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SettingsModal.vue
// module id = null
// module chunks = 